import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerUnauthorizedDepartureDetail,
	formatWorkerUnauthorizedDepartureExcelList,
	formatWorkerUnauthorizedDepartureList,
} from './worker-unauthorized-departure.helper';
import { WorkerUnauthorizedDepartureActions } from './worker-unauthorized-departure.redux';
import {
	ICreateWorkerUnauthorizedDepartureRequest,
	IPayloadDeleteWorkerUnauthorizedDepartureRequest,
	IPayloadGetWorkerUnauthorizedDepartureDetailRequest,
	IPayloadGetWorkerUnauthorizedDepartureExcelListRequest,
	IPayloadGetWorkerUnauthorizedDepartureListRequest,
} from './worker-unauthorized-departure.type';

export function* getWorkerUnauthorizedDepartureListSaga(
	action: PayloadAction<IPayloadGetWorkerUnauthorizedDepartureListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerUnauthorizedDepartureListResponse> =
			yield API.getWorkerUnauthorizedDepartureList({ searchTypes, ...rest });
		const content = formatWorkerUnauthorizedDepartureList(res?.data?.content);

		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureListSuccess(
				{
					...rest,
					content,
					total: res?.data?.total,
				}
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureListFailure()
		);
	}
}

export function* getWorkerUnauthorizedDepartureExcelListSaga(
	action: PayloadAction<IPayloadGetWorkerUnauthorizedDepartureExcelListRequest>
) {
	const { searchTypes, callback, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerUnauthorizedDepartureListResponse> =
			yield API.getWorkerUnauthorizedDepartureList({ searchTypes, ...rest });
		const content = formatWorkerUnauthorizedDepartureExcelList(
			res?.data?.content
		);

		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureExcelListSuccess()
		);
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureExcelListFailure()
		);
	}
}

export function* getWorkerUnauthorizedDepartureDetail(
	action: PayloadAction<IPayloadGetWorkerUnauthorizedDepartureDetailRequest>
) {
	const { id, callback } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.IWorkerUnauthorizedDepartureDetail> =
			yield API.getWorkerUnauthorizedDepartureDetail(id);
		const workerUnauthorizedDepartureDetail =
			formatWorkerUnauthorizedDepartureDetail(res.data);

		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureDetailSuccess(
				{
					workerUnauthorizedDepartureDetail,
				}
			)
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerUnauthorizedDepartureActions.getWorkerUnauthorizedDepartureDetailFailure()
		);
	}
}

export function* deleteWorkerUnauthorizedDeparture(
	action: PayloadAction<IPayloadDeleteWorkerUnauthorizedDepartureRequest>
) {
	const { ids, callback } = action.payload;

	try {
		yield API.deleteWorkerUnauthorizedDeparture(ids);

		yield put(
			WorkerUnauthorizedDepartureActions.deleteWorkerUnauthorizedDepartureSuccess()
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerUnauthorizedDepartureActions.deleteWorkerUnauthorizedDepartureFailure()
		);
	}
}

export function* createWorkerUnauthorizedDeparture(
	action: PayloadAction<ICreateWorkerUnauthorizedDepartureRequest>
) {
	const { callback, data } = action.payload;

	try {
		yield API.createWorkerUnauthorizedDeparture(data);

		yield put(
			WorkerUnauthorizedDepartureActions.createWorkerUnauthorizedDepartureSuccess()
		);

		callback?.();
	} catch (error: unknown) {
		callback?.(error as API.ApiResponseError);

		yield put(
			WorkerUnauthorizedDepartureActions.createWorkerUnauthorizedDepartureFailure()
		);
	}
}
